<template>
    <v-container>
    <v-card>
      <v-card-title>
        <h3>{{ id ? "Editar" : "Crear" }} Usuario</h3>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col>
              <v-checkbox label="Administrador" v-model="formUser.is_admin" />
            </v-col>
            <v-col>
              <v-checkbox label="Usuario Activo" v-model="formUser.estado" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                dense
                outlined
                label="Nombres"
                v-model="formUser.nombres"
                :rules="rulesFields"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                dense
                outlined
                label="Apellidos"
                v-model="formUser.apellidos"
                :rules="rulesFields"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                dense
                outlined
                label="Email"
                v-model="formUser.email"
                :rules="rulesFields"
              />
            </v-col>
            <v-col cols="6" class="d-flex flex-nowrap">
              <v-text-field
                style="width:95%"
                dense
                outlined
                label="Run"
                v-model="formUser.run"
                :rules="rulesFields"
              />
              <span class="mt-4 mx-2"> - </span>
              <v-text-field
                style="width:20%"
                dense
                outlined
                label="Dv"
                v-model="formUser.dv"
                :rules="rulesFields"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-select
                outlined
                v-model="formUser.subdireccion_id"
                label="Subdirección"
                :items="subdirecciones"
                item-text="nombre"
                item-value="id"
                :rules="rulesFields"
                dense
                chips
              />
            </v-col>
            <v-col cols="6">
              <v-select
              v-model="formUser.accesos"
              outlined
              label="Permisos"
              :items="permisos"
              item-text="nombre"
              item-value="id"
              multiple
              dense
              chips
              deletable-chips
              :rules="rulesFields"
              />
            </v-col>
          </v-row>
        </v-form>
        <v-row>
          <v-col class="d-flex justify-end">
            <v-btn @click="goBack()" class="mr-5" color="error">Cancelar</v-btn>
          <v-btn
            v-if="!id"
            @click="saveNewUser()"
            :disabled="!validBtnSave"
            color="primary"
            >Guardar</v-btn
          >
          <v-btn
            v-else
            @click="editUser()"
            :disabled="!validBtnSave"
            color="primary"
            >Editar</v-btn
          >
          </v-col>
        </v-row>
      </v-card-text>

    </v-card>
    </v-container>
  </template>
  
  <script>
  import {UserService} from "../../util/Api/Usuarios/calls"
  import { Loading } from "element-ui";
  import Swal from "sweetalert2";

  export default {
    props: ["id"],
    name: "UsuarioCompontent",
    data() {
      return {
        rulesFields: [(v) => !!v || "El campo es requerido"],
        valid: false,
        subdirecciones: [],
        permisos:[],
        formUser: {
          is_admin: false,
          nombres: "",
          apellidos: "",
          email: "",
          run: null,
          dv: null,
          estado: true,
          subdireccion_id: null,
          accesos:null,
        },
      };
    },
    computed: {
      validBtnSave() {
        return (
          this.formUser.nombres !== "" &&
          this.formUser.apellidos !== "" &&
          this.formUser.email !== "" &&
          this.formUser.run !== null &&
          this.formUser.dv !== null &&
          this.formUser.subdireccion_id !== null &&
          this.formUser.accesos !== null
        );
      },


    },

    mounted(){
      this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "Cargando..",
          background: "rgba(0, 0, 0, 0.8)",
        });
      this.getPermissions();
      this.getSubdirecciones();

      if (this.id) {
        this.getUsuario()
      }

      this.loadingInstance.close();
    },
    methods: {

      async getPermissions(){
        try {
          this.permisos= await UserService.getPermissions(); 
        } catch (error) {
          Swal.fire({
          type: "error",
          html: `Error al cargar los Permisos: ${error}`,
          });
        }
      },
      async getSubdirecciones(){
        try {
          this.subdirecciones= await UserService.getSubdirecciones(); 
        } catch (error) {
          Swal.fire({
          type: "error",
          html: `Error al cargar las subdirecciones: ${error}`,
          });
        }
      },

      async getUsuario(){
        try {
          this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "Cargando..",
          background: "rgba(0, 0, 0, 0.8)",
        });
          const user= await UserService.getUser(this.id)
              // Verificamos si el objeto tiene la propiedad "accesos" y si es un array
            if (Array.isArray(user.accesos)) {
                // Mapeamos el array de accesos para obtener solo los IDs
                user.accesos = user.accesos.map(acceso => acceso.id);
            }else{
              user.accesos=[]
            }
            
            this.formUser.is_admin = user.is_admin
            this.formUser.nombres = user.nombres
            this.formUser.apellidos = user.apellidos
            this.formUser.email = user.email
            this.formUser.run = user.run
            this.formUser.dv = user.dv
            this.formUser.estado = user.estado
            this.formUser.subdireccion_id = user.subdireccion_id
            this.formUser.accesos = user.accesos

        }catch (error) {
          Swal.fire({
          type: "error",
          html: `Error al cargar el usuario: ${error}`,
          });
        }
      },
      goBack() {
        this.$router.push({ name: "usuarios" });
      },
      async saveNewUser() {
        try {
          const params=this.formUser
          
          const resp= await UserService.createUser(params)
          console.log('resp:::',resp);
          if(resp.statusCode !=200 && resp.statusCode!=201 ){
            throw resp.msg
          }
          this.loadingInstance.close();
          Swal.fire({
          type: "success",
          html: `Usuario Creado Con exito`,
          });
          this.goBack();
        } catch (error) {
          this.loadingInstance.close();
          console.log('error en catch:::',error);
          Swal.fire({
          type: "error",
          html: `Error al cargar el usuario: ${JSON.stringify(error)}`,
          });
        }
      },
      async editUser() {
        try {
          const params=this.formUser
          params.id=this.id
          
          const resp= await UserService.editUser(params)
          console.log('resp:::',resp);
          if(resp.statusCode !=200 && resp.statusCode!=201 ){
            throw resp.msg
          }
          this.loadingInstance.close();
          Swal.fire({
          type: "success",
          html: `Usuario Editado Con exito`,
          });
          this.goBack();
        } catch (error) {
          this.loadingInstance.close();
          console.log(error);
          Swal.fire({
          type: "error",
          html: `Error al cargar el usuario: ${error}`,
          });
        }
      },
    },
  };
  </script>
  
  <style lang="scss" scoped></style>